import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
var _pathname;
export var injectOrganizationId = function(to, orgId) {
    return typeof to === "string" ? injectOrg(to, orgId) : _object_spread_props(_object_spread({}, to), {
        pathname: injectOrg((_pathname = to.pathname) !== null && _pathname !== void 0 ? _pathname : "", orgId)
    });
};
var injectOrg = function(path, orgId) {
    if (path.startsWith("/".concat(orgId, "/")) || // Don't prepend the orgId if it's already there
    !path.startsWith("/") // Don't prepend the ordId if it's a relative path
    ) {
        return path;
    }
    return "/".concat(orgId).concat(path);
};

//# sourceMappingURL=injectOrganizationId.js.map